import React from "react";

// One coherent MELLETIC CEFR badge family (A1 light blue → C2 navy + restrained gold).
const STYLES = {
  A1: { bg: "#E0F2FE", fg: "#2563EB", bd: "#BFE3FB" },
  A2: { bg: "#DBEAFE", fg: "#3B82F6", bd: "#BFDBFE" },
  B1: { bg: "#2563EB", fg: "#FFFFFF", bd: "#2563EB" },
  B2: { bg: "#1D4ED8", fg: "#FFFFFF", bd: "#1D4ED8" },
  C1: { bg: "#312E81", fg: "#C7D2FE", bd: "#312E81" },
  C2: { bg: "#0F172A", fg: "#FBBF24", bd: "#0F172A" },
};

export default function CefrBadge({ level = "A1", size = "md", className = "" }) {
  const s = STYLES[level] || STYLES.A1;
  const dims = size === "sm" ? "text-[11px] px-2 py-0.5" : size === "lg" ? "text-sm px-3.5 py-1.5" : "text-xs px-3 py-1";
  return (
    <span
      data-testid={`cefr-badge-${level}`}
      className={`inline-flex items-center font-extrabold tracking-wide rounded-full border ${dims} ${className}`}
      style={{ background: s.bg, color: s.fg, borderColor: s.bd }}
    >
      {level}
    </span>
  );
}
